import makeBasicElement from '../util/makeBasicElement';
import { cn } from '../../utils/cn';
export const Input = makeBasicElement('input', cn('appearance-none', 'block', 'w-full', 'rounded border', 'py-3 px-4', 'leading-tight', 'overflow-hidden', 'focus:outline-none', 'focus:bg-gesso'));
